import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"icon-account\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.117 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm5.58 12.15c1.12.82 1.83 2.24 1.91 4.85H1.627c.08-2.6.79-4.03 1.9-4.85 1.25-.9 3.09-1.15 5.59-1.15s4.35.26 5.58 1.15ZM9.117 10c-2.5 0-4.65.24-6.17 1.35-1.56 1.13-2.33 3.08-2.33 6.15v.5h17v-.5c0-3.07-.77-5.02-2.33-6.15-1.52-1.1-3.67-1.35-6.17-1.35Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol